import { render, staticRenderFns } from "./docs-per-message-type-pie.vue?vue&type=template&id=f0380d22&scoped=true&"
import script from "./docs-per-message-type-pie.vue?vue&type=script&lang=js&"
export * from "./docs-per-message-type-pie.vue?vue&type=script&lang=js&"
import style0 from "./docs-per-message-type-pie.vue?vue&type=style&index=0&id=f0380d22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0380d22",
  null
  
)

export default component.exports